import { mergeMap } from 'rxjs/operators';
import { performAddEventProfileTranslations } from '~admin/interactor/event/perform-add-event-profile-translations';
import { performUpdateEventProfile } from '~admin/interactor/event/perform-update-event-profile';
import { getEventTranslationRequest } from '~admin/view/components/create-event/helper/event-profile-request.helper';
import { EventFormData } from '~admin/view/components/details/event-form-data';
import { getEventProfileUpdateRequest } from '~admin/view/components/edit-event/helper/event-profile-update-request.helper';
import { EventResponse } from '~client/model/admin/event-response';
import { ResponseEntity } from '~client/model/response-entity';
import { rxTask, TwoArgTask } from '~common/helper/mobx-tasks';

export type UpdateEventTask = TwoArgTask<number, EventFormData, ResponseEntity>;

export const updateEventTaskFactory = (): UpdateEventTask =>
  rxTask<number, EventFormData, any>((eventId: number, eventData: EventFormData) =>
    performUpdateEventProfile(getEventProfileUpdateRequest(eventId, eventData)).pipe(
      mergeMap((updateEventProfileResponse: EventResponse) =>
        performAddEventProfileTranslations(
          getEventTranslationRequest(
            updateEventProfileResponse.id.toString(),
            updateEventProfileResponse.eventRestrictions,
            updateEventProfileResponse.eventTimelineGroups,
            eventData,
          ),
        ),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./interactor/event/update-event.ts